import ReactGA from 'react-ga'

export const GoogleSaveEvent = (category, data, value) =>{
    ReactGA.event({
        category: category,
        action: JSON.stringify(data),
        value: value
    });
}